import React from "react";
import "./style.css";
import { Container, Row, Col } from "react-bootstrap";
import { services } from "../../content_option";
import Reveal from "../../components/reveal";

export const Services = () => {
  return (
    <section id="services" className="About-header">
      <Container>
        <Row className="mb-4 mt-3 pt-md-3">
          <Col lg="8">
            <h1 className="display-4 mb-4">Services</h1>
            <hr className="t_border my-4 ml-0 text-left" />
            <p className="sv_subtitle">
              Video editing for creators, businesses, and brands—from YouTube videos and vlogs to Reels, Shorts, and product content.
            </p>
          </Col>
        </Row>
        <div className="sv_grid">
          {services.map((data, i) => (
            <Reveal key={i} delay={i * 80} className="sv_card glass">
              <span className="sv_num">{String(i + 1).padStart(2, "0")}</span>
              <h5 className="sv_title">{data.title}</h5>
              <p className="sv_desc">{data.description}</p>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  );
};
